module.exports = __webpack_public_path__ + "img/frame (49).d444cfb9.jpg";